import { ProblemDetails } from "../models/Http";
import { Person } from "../models/Person";
import { get, post, put } from "./api";
import { err, ok, Result, Unit } from "../result";
import { UserRule } from "../models/UserRule";
import { AdminUser, Authenticated } from "../models/User";

export const list = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<Person>>
> => {
  const response = await get(`/v1/people`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<Person>);
  }

  return err(content as ProblemDetails);
};

export const listWithTenantAccess = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<Person>>
> => {
  const response = await get(`/v1/people/list`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<Person>);
  }

  return err(content as ProblemDetails);
};

export const updateProfile = async (
  profile: AdminUser
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await put(`/v1/people/profile`, profile);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();

  return err(content as ProblemDetails);
};

export const updateManager = async (
  id: string,
  manager: AdminUser
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await put(`/v1/people/${id}/profile`, manager);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();

  return err(content as ProblemDetails);
};

export const getProfile = async (): Promise<
  Result<ProblemDetails, Authenticated>
> => {
  const response = await get(`/v1/people/profile`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as Authenticated);
  }

  return err(content as ProblemDetails);
};
